module.exports = __webpack_public_path__ + "img/chiku02.b730b49b.png";